<template>
  <div class="notes-page pt-3">
    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <Loader v-if="loading" />

    <div
      v-if="userCanAdd"
      class="pt-2 mb-3">
      <button class="btn btn-primary" @click="showForm = true">
        Добавить заметку
      </button>
    </div>

    <Form
        v-if="(userCanAdd || userCanEdit) && showForm"
        :note="note"
        :client="client"
        v-on:cancel="closeForm"
        v-on:submit="submitForm" />

    <List
        :notes="notes"
        v-on:select="selectNote"/>
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import Form from './note/Form';
import List from './note/List';

export default {
  name: 'ClientNote',

  components: {Loader, Flash, List, Form},

  props: ['client'],

  data() {
    return {
      loading: false,
      showForm: false,
      noteId: null,
      error: '',
      success: '',
    };
  },

  created() {
    this.loadUserData();
  },

  computed: {
    notes() {
      const notes = this.$store.getters.clientNotes(this.client.id);

      notes.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      return notes;
    },

    note() {
      return this.notes.find(note => note.id === this.noteId);
    },

    userCanAdd() {
      return this.$security.voters.note.canAdd(this.$store.state.user);
    },

    userCanEdit() {
      return this.$security.voters.note.canEdit(this.$store.state.user);
    },
  },

  methods: {
    async loadUserData() {
      try {
        this.loading = true;

        await this.$store.dispatch('LOAD_NOTES', this.client.id);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    selectNote(id) {
      if (!this.userCanEdit) {
        return;
      }

      this.noteId = id;
      this.showForm = true;
    },

    closeForm() {
      this.noteId = null;
      this.showForm = false;
    },

    async submitForm(text) {
      try {
        this.loading = true;

        let method = 'ADD_NOTE';
        const data = { client: this.client.id, text };

        if (typeof this.note !== 'undefined') {
          method = 'UPDATE_NOTE';
          Object.assign(data, { id: this.note.id });
        }

        await this.$store.dispatch(method, data);

        this.showForm = false;
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
